const url = "https://liveapi.bookyarra.com/"; //https://api.sunshinelifestyle.in" // process.env.REACT_APP_BACKEND_URL // 'http://localhost:4001';
const config = {
  backendUrl: `${url}api/v1`,
  frontendUrl: `https://bookyarra.com`,
  Imageurl: url,
  AES256Secret: "ac592ea14b975c79c7257281dbeef1ed",
  NoImage: "/assets/img/BookYarra/noimage.png",
  portalUrl: "https://business.bookyarra.com"
  // portalUrl: "http://localhost:3001"
};


module.exports = config;